import { TargetPathPositionData } from 'ais-facade-api/api';

type FakePointsT = [number, number[], number[]][];

export const getOptimalRoute = (origin: TargetPathPositionData[] | any): any[] | undefined => {
  const fakePoints: FakePointsT = findSlices(origin);

  const result: any[] = [];
  if (fakePoints.length === 0) {
    return [origin];
  }

  if (fakePoints.length > 0) {
    let i = 0;

    do {
      if (i < fakePoints.length) {
        const arr = origin.slice(i > 0 ? fakePoints[i - 1][0] : i, fakePoints[i][0]);
        if (i === 0) {
          arr.push({ lon: fakePoints[i][1][0], lat: fakePoints[i][1][1] });
          result.push(arr);
        } else {
          arr.unshift({ lon: fakePoints[i - 1][2][0], lat: fakePoints[i - 1][2][1] });
          arr.push({ lon: fakePoints[i][1][0], lat: fakePoints[i][1][1] });
          result.push(arr);
        }
        i++;
      } else {
        const arr = origin.slice(fakePoints[i - 1][0], origin.length);
        arr.unshift({ lon: fakePoints[i - 1][2][0], lat: fakePoints[i - 1][2][1] });
        result.push(arr);
        i++;
      }
    } while (i < fakePoints.length + 1);
    return result;
  }
};

const findSlices = (origin: TargetPathPositionData[]) => {
  const separators: [number, number[], number[]][] = [];
  for (let i = 1; i < origin.length; i++) {
    const cur = origin[i];
    const prev = origin[i - 1];
    if (cur.lon && prev.lon && Math.abs(cur.lon + 180 - (prev.lon + 180)) > 180) {
      const intersectionLatitude = calculateLatitude(cur, prev);
      const sign = cur.lon >= 0 ? -1 : 1;
      if (intersectionLatitude) {
        const p1: number[] = [180 * sign, intersectionLatitude];
        const p2: number[] = [180 * -sign, intersectionLatitude];
        separators.push([i, p1, p2]);
      }
    }
  }
  return separators;
};

const calculateLatitude = (p1: TargetPathPositionData, p2: TargetPathPositionData) => {
  const pc1 = { latitude: p1.lat, longitude: p1.lon && p1.lon < 0 ? p1.lon + 360 : p1.lon };
  const pc2 = { latitude: p2.lat, longitude: p2.lon && p2.lon < 0 ? p2.lon + 360 : p2.lon };

  const d1 = { latitude: -90, longitude: 180 };
  const d2 = { latitude: 90, longitude: 180 };

  const a1 = pc2.latitude && pc1.latitude && pc2.latitude - pc1.latitude;
  const b1 = pc1.longitude && pc2.longitude && pc1.longitude - pc2.longitude;
  const c1 = a1 && b1 && pc1.longitude && pc1.latitude && a1 * pc1.longitude + b1 * pc1.latitude;

  const a2 = d2.latitude - d1.latitude;
  const b2 = d1.longitude - d2.longitude;
  const c2 = a2 * d1.longitude + b2 * d1.latitude;

  const delta = a1 && b1 && a1 * b2 - a2 * b1;

  if (a1 && c1 && delta) {
    return (a1 * c2 - a2 * c1) / delta;
  }
};

// const removeExtraPoints = (origin: TargetPathPositionData[]) => {
//   const result = [];
//   for (let i = 1; i < origin.length; i++) {
//     const cur = origin[i];
//     const prev = origin[i - 1];

//     if (cur.cog && prev.cog && Math.round(prev.cog - cur.cog) >= 2) {
//       result.push(prev);
//     }
//     if (i === origin.length - 1) {
//       result.push(prev, cur);
//     }
//     if (!!cur.sog || !!prev.sog) {
//       result.push(cur);
//     }
//   }

//   return result;
// };
